import { SpineAnimation } from '@base/spineAnimation/SpineAnimation'

export const LOGO_ANIMATION_IDLE = 'idle'
export const LOGO_ANIMATION_WIN = 'win'
const LOGO_WIN_INTERVAL_MS = 10000

const logoTimers = new WeakMap<SpineAnimation, ReturnType<typeof setInterval>>()
const logoWinPlaying = new WeakMap<SpineAnimation, boolean>()

const playLogoIdle = (container: SpineAnimation): void => {
    try {
        container.start([LOGO_ANIMATION_IDLE], [true], 0, [1])
    } catch (error) {
        container.start(['idle'], [true], 0, [1])
    }
}

const playLogoWin = (container: SpineAnimation): void => {
    if (!container.visible || logoWinPlaying.get(container)) {
        return
    }

    logoWinPlaying.set(container, true)
    container.start([LOGO_ANIMATION_WIN], [false], 0, [1], () => {
        logoWinPlaying.set(container, false)
        if (!container.visible) {
            return
        }

        playLogoIdle(container)
    })
}

/**
 * Starts logo flourish immediately when base game is first shown,
 * then repeats the flourish every 10 seconds.
 * Subsequent calls (e.g. spin start) only keep idle — they do not re-trigger win.
 */
export const startLogoAnimation = (container: SpineAnimation): void => {
    if (logoTimers.has(container)) {
        if (!logoWinPlaying.get(container) && container.visible) {
            playLogoIdle(container)
        }
        return
    }

    playLogoWin(container)

    logoTimers.set(
        container,
        setInterval(() => {
            playLogoWin(container)
        }, LOGO_WIN_INTERVAL_MS)
    )
}
